import {
  NotificationBO,
  NotificationsPageBO,
} from "@/api/graphql/notifications/types.ts";
import { GetNotificationsByUserQueryQuery } from "@/api/graphql/types/graphql.ts";

type NotificationQueryResult = NonNullable<
  GetNotificationsByUserQueryQuery["NotificationsMsSearchNotifications"]["data"]
>[number];

const mapNotificationFromGraphQL = (
  rawNotification: NotificationQueryResult,
): NotificationBO => ({
  id: rawNotification.id,
  subject: rawNotification.subject,
  hasAttachments: rawNotification.hasAttachments,
  createdTs: rawNotification.createdTs,
  accountNumber: rawNotification.AccountIdData?.number,
  accountName: rawNotification.AccountIdData?.name,
  status: rawNotification.status,
  failedReason: rawNotification.failedReason,
});

export const mapNotificationsFromUserGraphQL = (
  rawNotifications: NotificationQueryResult[] | undefined,
): NotificationBO[] => rawNotifications?.map(mapNotificationFromGraphQL) ?? [];

export const mapNotificationsFromAccountGraphQL = (
  rawNotifications: NotificationQueryResult[] | undefined,
): NotificationBO[] => rawNotifications?.map(mapNotificationFromGraphQL) ?? [];

export const mapNotificationsPageFromGraphQL = (
  rawPage:
    | GetNotificationsByUserQueryQuery["NotificationsMsSearchNotifications"]
    | null
    | undefined,
): NotificationsPageBO | undefined => {
  if (!rawPage) {
    return;
  }

  return {
    data: mapNotificationsFromUserGraphQL(rawPage.data ?? []),
    pagination: {
      page: rawPage.pagination.page,
      size: rawPage.pagination.size,
      total: rawPage.pagination.total,
    },
  };
};
